/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Flex = makeShortcode("Flex");
const Heading = makeShortcode("Heading");
const Box = makeShortcode("Box");
const Text = makeShortcode("Text");
const Tweet = makeShortcode("Tweet");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Flex direction="column" w="100%" h="500px" bg="brand.background" justify="center" align="center" mdxType="Flex">
      <Heading fontSize={["4xl", "4xl", "6xl"]} fontWeight="normal" color="brand.text" m={[3, 3, null]} align="center" mdxType="Heading">
  This is the second page
      </Heading>
    </Flex>
    <Box bg="brand.accent" mt={-10} p={6} mdxType="Box">
  <Text fontSize="3xl" fontWeight="normal" color="brand.background" m={[3, 3, null]} align="center" mdxType="Text">
This is an embedded tweet. You can embed all sorts of cool things with mdx-embed.
      </Text>
      <Box bg="brand.accent" minH="500px" mdxType="Box">
  <Tweet tweetLink="https://twitter.com/studio_hungry/status/1256343990061936640?s=20" align="center" theme="dark" mdxType="Tweet" />
      </Box>
    </Box>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
